var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SwitchMap',{attrs:{"datas":_vm.datas,"mapItemClick":_vm.mapItemClick,"title":"选择地图"}})}
var staticRenderFns = []

export { render, staticRenderFns }